import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip as ChartTooltip,
  XAxis,
  YAxis,
} from "recharts";
import PageLoading from "../../../../components/Loading/PageLoading";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../../context/LodingContext";
import BASEURL from "../../../../pages/Utils/Baseurl";
import request from "graphql-request";
import {
  allCustomers,
  allUsers,
  exportPaymentFollow,
  PaymentFollowFilter,
  todayCustomersDropdown,
} from "../ReportData";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { downloadExcelFile } from "../../../function/downloadExcel";
import _ from "lodash";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../ReportStateMange";
import OptionConvert from "../../../components/OptionConvert";
import Swal from "sweetalert2";
import { getCurrentPaymentBalance } from "../../paymentBalance/PaymentBalanceData";
import URL from "../../../../pages/Utils/url";
import ReusableFilter from "../../../components/ReusableFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import ReportDefaultUi from "../reportDefaultui";
import AppliedFilter from "../AppliedFilter/AppliedFilter";
import ReportGraphPanel from "../ReportGraphPanel";

const PaymentFollow = () => {
  const [paymentData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState,
  );
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [datas, setData] = useState([]);
  const [customerRawData, setCustomerRawData] = useState([]); // Store raw customer data for autocomplete
  const [isLoading, setIsLoading] = useState(false);
  const [isTabel, setIsTabel] = useState(false);

  const [error, setError] = useState("");
  const [value, setValue] = useState(0);
  const [dateerror, setdateerror] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [agentOptions, setAgentOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [customerOptions, setCustomerOptions] = useState([
    { label: "All", value: "All" },
  ]);

  // Graph pagination follows the same server page as the table.
  const [currentPage, setCurrentPage] = useState(0);
  const [tablePaginationModel, setTablePaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [serverTotalPages, setServerTotalPages] = useState(0);
  const [activeReportFilters, setActiveReportFilters] = useState(null);
  const hasSelectedFilters = Boolean(
    (paymentData?.fromDate && paymentData?.toDate) ||
      paymentData?.agentName?.length ||
      paymentData?.customerName?.length,
  );

  const totalPages = serverTotalPages;
  const currentGraphData = datas;

  useEffect(() => {
    fetchCustomerAndAgent();
    // fetchFilteredStock();
    setIsTabel(false);
  }, []);

  useEffect(() => {
    if (value === 1 && !paymentData?.fromDate && !paymentData?.toDate) {
      const today = new Date();
      const last30Days = new Date();
      last30Days.setDate(today.getDate() - 30);
      const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      dispatch({ value: formatDate(today), name: "toDate" });
      dispatch({ value: formatDate(last30Days), name: "fromDate" });
    }
  }, [value, paymentData?.fromDate, paymentData?.toDate]);

  const PaymentBalaneceListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Rep Name",
        field: "repName",
        name: "repName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Customer Name",
        field: "customerName",
        name: "customerName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Balance",
        field: "balance",
        name: "balance",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Paid Amount",
        field: "remainingAmount", // This field seems to be "Remaining Amount" in the graph, but "Paid Amount" in table
        name: "remainingAmount",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Status",
        field: "status",
        name: "status",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Created By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: datas?.map((v, i) => ({
      sno: i + 1,
      id: i + 1,
      repName: v?.repName,
      customerName: v?.customerName,
      balance: v?.balance,
      remainingAmount: v?.remainingAmount || v?.amountPaid, // Make sure this is the correct field for 'Paid Amount'
      status: v?.status,
      createdBy: v?.user?.employeeName,

      Action: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <VisibilityIcon
            style={{ color: "GrayText", fontSize: "20px", cursor: "pointer" }}
            onClick={() =>
              navigate(`/payment-follow/view-payment-follow`, {
                state: { type: "view", data: v },
              })
            }
          />
        </div>
      ),
    })),
  };

  //download excel file
  const handleDownload = () => {
    const customers =
      paymentData?.customerName?.length > 0
        ? paymentData?.customerName?.map((item) => item.label) || []
        : [];
    const agents =
      paymentData?.agentName?.length > 0
        ? paymentData?.agentName?.map((item) => item.label) || []
        : [];

    setCirleLoading(true);
    request(BASEURL, exportPaymentFollow, {
      startDate: paymentData?.fromDate,
      endDate: paymentData?.toDate,
      customers,
      agents,
    })
      .then(async (res) => {
        const status = res?.exportFilteredPaymentBalances?.success;
        const pdfurl = `${URL}${res?.exportFilteredPaymentBalances?.fileUrl?.slice(
          1,
        )}`;
        if (status) {
          await downloadExcelFile(pdfurl, "payment_follow_report.xlsx");
          setCirleLoading(false);
        }
      })
      .catch((err) => {
        setCirleLoading(false);
        Swal.fire({
          position: "top",
          icon: "error",
          title: "Failed to download file.",
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  //get PaymentFollowData table data
  const fetchPaymentFollowData = () => {
    setIsLoading(true);
    request(BASEURL, getCurrentPaymentBalance, {
      paginate: false,
    })
      .then((res) => {
        const newdata = res?.allPaymentBalance?.data;
        setData(newdata);
        // Store raw data for customer autocomplete as it's needed for initial options
        setCustomerRawData(newdata);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //get customer option
  const fetchCustomerAndAgent = () => {
    Promise.all([
      request(BASEURL, todayCustomersDropdown), // customers
      request(BASEURL, allUsers), // agents
    ])
      .then(([customerRes, agentRes]) => {
        // ---- Customers ----
        const customerName = OptionConvert(
          customerRes?.todayCustomersDropdown?.data,
          "customerName",
          "id",
        );
        setCustomerOptions((prev) => [...prev, ...customerName]);

        // ---- Agents ----
        const agentName = OptionConvert(
          agentRes?.allUsers,
          "employeeName",
          "id",
        );
        setAgentOptions((prev) => [...prev, ...agentName]);
      })
      .finally(() => {});
  };

  const resetFilters = () => {
    dispatch({ name: "reset" });
    setActiveReportFilters(null);
    setData([]);
    setTotalCount(0);
    setServerTotalPages(0);
    setTablePaginationModel({ page: 0, pageSize: 10 });
    setIsTabel(false);
    setIsLoading(false);
    setCurrentPage(0);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCurrentPage(tablePaginationModel.page);
  };

  const handleGraphPageChange = (page) => {
    if (
      !activeReportFilters ||
      isLoading ||
      page < 0 ||
      page >= serverTotalPages
    ) {
      return;
    }

    fetchFilteredStock(
      activeReportFilters.startDate,
      activeReportFilters.endDate,
      activeReportFilters.agents,
      activeReportFilters.customers,
      page,
      tablePaginationModel.pageSize,
    );
  };

  const handleTablePaginationChange = (model) => {
    if (
      model.page === tablePaginationModel.page &&
      model.pageSize === tablePaginationModel.pageSize
    ) {
      return;
    }

    const nextModel = {
      page: model.pageSize !== tablePaginationModel.pageSize ? 0 : model.page,
      pageSize: model.pageSize,
    };
    setTablePaginationModel(nextModel);

    if (activeReportFilters) {
      fetchFilteredStock(
        activeReportFilters.startDate,
        activeReportFilters.endDate,
        activeReportFilters.agents,
        activeReportFilters.customers,
        nextModel.page,
        nextModel.pageSize,
      );
    }
  };

  const submitFilter = (data) => {
    const agentName =
      paymentData?.agentName?.length > 0
        ? paymentData?.agentName.map((item) => item.label)
        : [];
    const customerName =
      paymentData?.customerName?.length > 0
        ? paymentData?.customerName.map((item) => item.label)
        : [];

    const filters = {
      startDate: paymentData.fromDate,
      endDate: paymentData.toDate,
      agents: agentName,
      customers: customerName,
    };
    setActiveReportFilters(filters);
    setTablePaginationModel({ page: 0, pageSize: 10 });
    setCurrentPage(0);
    fetchFilteredStock(
      filters.startDate,
      filters.endDate,
      filters.agents,
      filters.customers,
      0,
      10,
    );
  };

  //filter api call
  const fetchFilteredStock = (
    startDate,
    endDate,
    agents,
    customers,
    page = 0,
    pageSize = 10,
  ) => {
    setIsLoading(true);
    setIsTabel(true);
    const payload = {
      startDate: startDate || null,
      endDate: endDate || null,
      customers: customers || [],
      agents: agents || [],
      page: page + 1,
      pageSize,
    };

    request(BASEURL, PaymentFollowFilter, payload)
      .then((res) => {
        const result = res?.paymentFollowUpReport;
        setData(result?.data || []);
        setTotalCount(result?.totalCount || 0);
        setServerTotalPages(result?.totalPages || 0);
        setCurrentPage(Math.max((result?.currentPage || page + 1) - 1, 0));
        setTablePaginationModel({
          page: Math.max((result?.currentPage || page + 1) - 1, 0),
          pageSize,
        });
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
        setIsTabel(true);
      });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Payment Follow Report
                </MaterialTypography>
              </Stack>
              <Box sx={{ mx: "5%" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {datas.length > 0 && (
                    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        TabIndicatorProps={{
                          style: {
                            backgroundColor: "#2a9941",
                            color: "white",
                          },
                        }}
                        sx={{ px: 2 }}
                        centered
                      >
                        <Tab sx={{ px: 2 }} label="Table list view" />
                        <Tab sx={{ px: 2 }} label="Graph view" />
                      </Tabs>
                    </Box>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      bgcolor: "background.paper",
                    }}
                  >
                    <IconButton
                      onClick={() => setDialogOpen(true)}
                      aria-label="Filters"
                      color="primary"
                    >
                      <FilterListIcon fontSize="medium" />
                    </IconButton>
                    <IconButton
                      onClick={resetFilters}
                      aria-label="Reset Filters"
                      color="primary"
                    >
                      <RefreshIcon fontSize="medium" />
                    </IconButton>
                  </Box>
                </Stack>
              </Box>
              {paymentData?.fromDate && paymentData?.toDate && !dateerror && (
                <button
                  className="container-btn-file"
                  onClick={handleDownload}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
            </Stack>
          }
        />
        {/* tabs */}

        {hasSelectedFilters || (!isTabel && datas.length === 0) ? (
          <AppliedFilter
            onSave={(data) =>
              submitFilter({
                ...data,
                paymentData,
              })
            }
            data={paymentData}
            dispatch={dispatch}
            chipDisplay={["agentName", "customerName"]}
          />
        ) : null}
        <ReusableFilter
          data={paymentData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              paymentData,
            })
          }
          title="Payment Follow Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agent Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={agentOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={paymentData?.agentName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "agentName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Customer Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={customerOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={paymentData?.customerName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "customerName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>
        </ReusableFilter>

        {!isLoading && isTabel && (
          <>
            {value === 0 ? (
              //Table list view
              <Box>
                {!isLoading && (
                  <MaterialDataGrid
                    rows={PaymentBalaneceListTable?.rows}
                    columns={PaymentBalaneceListTable?.columns}
                    isSelectable={false}
                    paginationMode="server"
                    paginationModel={tablePaginationModel}
                    onPaginationModelChange={handleTablePaginationChange}
                    // pageSizeOptions={[10, 25, 50]}
                    rowCount={totalCount}
                    localeText={{
                      noRowsLabel: (
                        <Stack
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                          spacing={1}
                        >
                          <MaterialTypography
                            variant="body2"
                            fontWeight="medium"
                            color="text"
                          >
                            No results match your filters
                          </MaterialTypography>

                          <MaterialTypography variant="caption" color="text">
                            Try adjusting or clearing the filters to see Payment
                            Follow data.
                          </MaterialTypography>
                        </Stack>
                      ),
                    }}
                  />
                )}
              </Box>
            ) : (
              //graph list view
              <ReportGraphPanel
                eyebrow="PAYMENT FOLLOW-UP"
                title="Receivables follow-up"
                description="Review remaining balances and partial payments by customer"
                page={currentPage}
                pageCount={totalPages}
                pageSize={tablePaginationModel.pageSize}
                totalCount={totalCount}
                isLoading={isLoading}
                onPageChange={handleGraphPageChange}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={currentGraphData}
                    margin={{ top: 24, right: 22, left: 4, bottom: 72 }}
                    barSize={16}
                  >
                    <CartesianGrid stroke="#e4ebe5" strokeDasharray="3 5" />
                    <XAxis
                      dataKey="customerName"
                      tick={{ fontSize: 9, fill: "#637168" }}
                      tickMargin={12}
                      tickFormatter={(name) =>
                        name?.length > 18 ? `${name.slice(0, 18)}...` : name
                      }
                      angle={-25}
                      textAnchor="end"
                      height={84}
                      interval={0}
                    />
                    <YAxis
                      tick={{ fontSize: 10, fill: "#637168" }}
                      tickMargin={8}
                    />
                    <ChartTooltip
                      contentStyle={{
                        fontSize: "11px",
                        borderRadius: "6px",
                        border: "1px solid #dfe8e1",
                        boxShadow: "0 5px 18px rgba(31, 55, 39, 0.12)",
                      }}
                      wrapperStyle={{
                        outline: "none",
                      }}
                    />
                    <Legend
                      verticalAlign="top"
                      align="right"
                      height={24}
                      wrapperStyle={{ fontSize: "11px", paddingBottom: "6px" }}
                    />
                    <Bar
                      dataKey="remainingAmount"
                      fill="#277b43"
                      name="Remaining Amount"
                    />
                    <Bar
                      dataKey="partialPaidAmount"
                      fill="#e4a64a"
                      name="Partial Paid Amount"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </ReportGraphPanel>
            )}
          </>
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default PaymentFollow;
